
import {
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";

interface ShareDialogHeaderProps {
  isPremium: boolean;
}

const ShareDialogHeader = ({ isPremium }: ShareDialogHeaderProps) => {
  return (
    <DialogHeader>
      <DialogTitle>Share Diary Entry</DialogTitle>
      <DialogDescription>
        {isPremium 
          ? "Share this diary entry with family members via email."
          : "Sharing is a premium feature. Upgrade to premium to share your diary entries."}
      </DialogDescription>
    </DialogHeader>
  );
};

export default ShareDialogHeader;
